import { call, put, takeEvery } from 'redux-saga/effects';
import { FetchCarriers, logisticsActionCreators, LogisticsActionKeys } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../logisticsApi';
import { ICarrier } from '../logisticsInterfaces';

function* fetchCarriersSaga(action: FetchCarriers) {
  yield put(uiActionCreators.toggleLoading('carriers'));
  const response: IApiExecuteRespone<ICarrier[]> = yield call(api.fetchCarriers);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(logisticsActionCreators.setCarriers(response.value));
  }

  yield put(uiActionCreators.toggleLoading('carriers'));
}

export function* watchFetchCarriers() {
  yield takeEvery(LogisticsActionKeys.FETCH_CARRIERS, fetchCarriersSaga);
}
